import { connect } from 'react-redux';
import ReportDailyFinanceComponent from './daily-finance.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {
		intl: null,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDailyFinanceComponent);



// WEBPACK FOOTER //
// ./src/components/report/daily-finance/daily-finance.ts